import {Injectable} from '@angular/core';

const STORAGE_KEY = 'accessiblePalette';

@Injectable({
    providedIn: 'root'
})
export class AccessiblePaletteService {
    // Safe to mirror in memory: this service is the only writer, and logout() clears storage
    private enabled = localStorage.getItem(STORAGE_KEY) === '1';

    public isEnabled(): boolean {
        return this.enabled;
    }

    public setEnabled(enabled: boolean): void {
        this.enabled = enabled;
        localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
    }
}
